// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-vWOa","col":"styles_col__3bzH5"};